<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <div v-else>
      <app-cells>
        <app-button @click.native="onOpenModalForm" size="small">Add comment</app-button>
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__created><div class="table-default__left">Created by</div></template>
        <template #h__comment><div class="table-default__left">Comment</div></template>
        <template #created="{ row }">
          <div v-if="row.created_by" class="table-default__controls table-default__left">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.created_by.crop.crop_url)" alt=""
                v-tooltip="{ content: row.created_by.full_name, placement: 'top-end', offset: 10 }"
              >
            </div>
            {{ formatDateTime(row.created_at) }}
          </div>
        </template>
        <template #comment="{ row }"><div class="table-default__left">{{ row.comment }}</div></template>
      </v-client-table>
      <app-cells :position="pagination.pages > 1 ? 'between' : 'end'">
        <paginate
          :clickHandler="onClickPagination"
          v-if="pagination.pages > 1"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" :limit="10" />
      </app-cells>
    </div>
    <modal
      name="create-form"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('create-form')" class="popup__close" type="button"></button>
        <div class="popup__title">Add comment</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Notes" label-for="notes" required>
              <app-textarea
                v-model="form.comment"
                id="notes"
                placeholder="Notes"
                :error="$v.form.comment.$error"
              />
              <template #error>
                <div v-if="$v.form.comment.$dirty && !$v.form.comment.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">Add</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import {
  getEmployeesComments, postEmployeesComment

} from '@/http'
import { format, parse, parseISO } from 'date-fns'

export default {
  name: 'EmployeeComments',
  data() {
    return {
      is_loaded: false,
      form: {},
      table_preloader: {},
      table: {
        items: [],
        columns: ['created', 'comment'],
        options: {
          headings: {
            created: 'Created by',
            comment: 'Comment',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  validations: {
    form: {
      comment: { required },
    },
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      this.table_preloader = true
      getEmployeesComments(this.$route.params.id, { page: this.pagination.page, page_size: 10 })
        .then(res => {
          this.table.items = res.data.results
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count

          this.is_loaded = true
          this.table_preloader = false
        })
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      postEmployeesComment(this.$route.params.id, this.form)
        .finally(() => { this.$refs.submit.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Comment added',
          })
          this.fetchItems()
          this.$modal.hide('create-form')
        })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    onOpenModalForm() {
      this.form = {}
      this.$v.form.$reset()
      this.$modal.show('create-form')
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    formatDateTime(date) {
      if (!date) return ''
      return format(parseISO(date), 'dd MMMM yyyy HH:mm')
    },
  }
}
</script>
